import React from "react";

interface OutlineUserIconProps {
  className?: string;
  size?: number;
  color?: string; strokeWidth?: number; strokeWidth2?: number;
}

const OutlineUserIcon: React.FC<OutlineUserIconProps> = ({
  size = 19,
  color = '#1E1E1E',
}) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.10573 7.24732C8.03906 7.24065 7.95906 7.24065 7.88573 7.24732C6.29906 7.19398 5.03906 5.89398 5.03906 4.29398C5.03906 2.66065 6.35906 1.33398 7.99906 1.33398C9.6324 1.33398 10.9591 2.66065 10.9591 4.29398C10.9524 5.89398 9.6924 7.19398 8.10573 7.24732Z" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4.7725 9.70602C3.15917 10.786 3.15917 12.546 4.7725 13.6193C6.60583 14.846 9.6125 14.846 11.4458 13.6193C13.0592 12.5393 13.0592 10.7793 11.4458 9.70602C9.61917 8.48602 6.6125 8.48602 4.7725 9.70602Z" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);

export default OutlineUserIcon;
